import Axios from 'axios';

const api = Axios.create({
});

export default api;



// WEBPACK FOOTER //
// ./src/api/api.js